module.exports = __webpack_public_path__ + "static/skill-3c6c5422d08d0874cd572b4cb3b5e894.webp";